import React from 'react';
import { FormattedMessage } from 'react-intl';

import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import Divider from '@components/Divider';
import H1 from '@components/atoms/H1';
import H3 from '@components/atoms/H3';
import Paragraph from '@components/atoms/Paragraph';

import { ContentWrapper, Line, TitleArea } from './styled';

const Connected = () => {
  return (
    <ContentWrapper>
      <H3 style={{ color: colors.exclusive100 }}>
        <FormattedMessage id="lounge.hero.welcome" />
      </H3>
      <TitleArea>
        <H1>
          <FormattedMessage id="lounge.hero.title" />
        </H1>
        <Line />
      </TitleArea>
      <Paragraph>
        <FormattedMessage id="lounge.hero.subtitle" />
      </Paragraph>
      <Divider />
    </ContentWrapper>
  );
};

export default Connected;
